import { Link } from "react-router-dom";
import { SUPPORT_EMAIL } from "@/lib/brand";
import { BrandLogo } from "@/components/BrandLogo";

export default function SiteFooter() {
  return <footer className="site-footer" data-testid="site-footer">
    <div className="brand-container footer-grid">
      <div className="footer-intro">
        <BrandLogo testId="footer-logo"/>
        <p>Personalised books, made from your memories.</p>
      </div>
      <nav className="footer-links" aria-label="Discover"><p className="eyebrow">Discover</p>
        <Link to="/#the-book" data-testid="footer-products">The book</Link>
        <Link to="/#how" data-testid="footer-how">How it works</Link>
        <Link to="/#made-for" data-testid="footer-made-for">Made for</Link>
        <Link to="/#faqs" data-testid="footer-faqs">FAQs</Link>
        <Link to="/projects" data-testid="footer-projects">Your saved books</Link>
      </nav>
      <nav className="footer-links" aria-label="Help"><p className="eyebrow">Help</p>
        <Link to="/contact" data-testid="footer-contact">Contact</Link>
        <Link to="/privacy" data-testid="footer-privacy">Privacy Policy</Link>
        <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-email">{SUPPORT_EMAIL}</a>
      </nav>
    </div>
    <div className="brand-container footer-bottom"><span data-testid="footer-copyright">© {new Date().getFullYear()} Keepsake Books</span></div>
  </footer>;
}
